/* tslint:disable */
/* eslint-disable */
/**
 * Commerce API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { AddonModel } from './AddonModel';
import {
    AddonModelFromJSON,
    AddonModelFromJSONTyped,
    AddonModelToJSON,
} from './AddonModel';
import type { Price } from './Price';
import {
    PriceFromJSON,
    PriceFromJSONTyped,
    PriceToJSON,
} from './Price';
import type { ProductSplashDiscountModel } from './ProductSplashDiscountModel';
import {
    ProductSplashDiscountModelFromJSON,
    ProductSplashDiscountModelFromJSONTyped,
    ProductSplashDiscountModelToJSON,
} from './ProductSplashDiscountModel';
import type { Specification } from './Specification';
import {
    SpecificationFromJSON,
    SpecificationFromJSONTyped,
    SpecificationToJSON,
} from './Specification';
import type { VariantGroup } from './VariantGroup';
import {
    VariantGroupFromJSON,
    VariantGroupFromJSONTyped,
    VariantGroupToJSON,
} from './VariantGroup';
import type { VariantOption } from './VariantOption';
import {
    VariantOptionFromJSON,
    VariantOptionFromJSONTyped,
    VariantOptionToJSON,
} from './VariantOption';
import type { VariantType } from './VariantType';
import {
    VariantTypeFromJSON,
    VariantTypeFromJSONTyped,
    VariantTypeToJSON,
} from './VariantType';

/**
 * 
 * @export
 * @interface ProductModel
 */
export interface ProductModel {
    /**
     * 
     * @type {Date}
     * @memberof ProductModel
     */
    campaignTo?: Date;
    /**
     * 
     * @type {Date}
     * @memberof ProductModel
     */
    campaignFrom?: Date;
    /**
     * 
     * @type {string}
     * @memberof ProductModel
     */
    shortDescription?: string;
    /**
     * 
     * @type {string}
     * @memberof ProductModel
     */
    longDescription?: string;
    /**
     * 
     * @type {Array<Array<string>>}
     * @memberof ProductModel
     */
    relatedProductIds?: Array<Array<string>>;
    /**
     * 
     * @type {Price}
     * @memberof ProductModel
     */
    price?: Price;
    /**
     * 
     * @type {string}
     * @memberof ProductModel
     */
    primaryTag?: string;
    /**
     * 
     * @type {string}
     * @memberof ProductModel
     */
    productType?: string;
    /**
     * 
     * @type {string}
     * @memberof ProductModel
     */
    seoTitle?: string;
    /**
     * 
     * @type {Price}
     * @memberof ProductModel
     */
    estimatedShippingPrice?: Price;
    /**
     * 
     * @type {string}
     * @memberof ProductModel
     */
    seoDescription?: string;
    /**
     * 
     * @type {string}
     * @memberof ProductModel
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof ProductModel
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof ProductModel
     */
    url?: string;
    /**
     * 
     * @type {Array<AddonModel>}
     * @memberof ProductModel
     */
    addons?: Array<AddonModel>;
    /**
     * 
     * @type {ProductSplashDiscountModel}
     * @memberof ProductModel
     */
    splash?: ProductSplashDiscountModel;
    /**
     * 
     * @type {string}
     * @memberof ProductModel
     */
    designer?: string;
    /**
     * 
     * @type {string}
     * @memberof ProductModel
     */
    googleProductCategory?: string;
    /**
     * 
     * @type {{ [key: string]: VariantGroup | undefined; }}
     * @memberof ProductModel
     */
    variantGroups?: { [key: string]: VariantGroup | undefined; };
    /**
     * 
     * @type {Array<VariantType>}
     * @memberof ProductModel
     */
    variantTypes?: Array<VariantType>;
    /**
     * 
     * @type {{ [key: string]: string | undefined; }}
     * @memberof ProductModel
     */
    variantPrices?: { [key: string]: string | undefined; };
    /**
     * 
     * @type {{ [key: string]: VariantOption | undefined; }}
     * @memberof ProductModel
     */
    options?: { [key: string]: VariantOption | undefined; };
    /**
     * 
     * @type {Array<Specification>}
     * @memberof ProductModel
     */
    specifications?: Array<Specification>;
    /**
     * 
     * @type {string}
     * @memberof ProductModel
     */
    brand?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof ProductModel
     */
    images?: Array<string>;
    /**
     * 
     * @type {{ [key: string]: Price | undefined; }}
     * @memberof ProductModel
     */
    priceDictionary?: { [key: string]: Price | undefined; };
    /**
     * 
     * @type {string}
     * @memberof ProductModel
     */
    categoryGroupCustomizerSelectionTitle?: string;
}

/**
 * Check if a given object implements the ProductModel interface.
 */
export function instanceOfProductModel(value: object): boolean {
    return true;
}

export function ProductModelFromJSON(json: any): ProductModel {
    return ProductModelFromJSONTyped(json, false);
}

export function ProductModelFromJSONTyped(json: any, ignoreDiscriminator: boolean): ProductModel {
    if (json == null) {
        return json;
    }
    return {
        
        'campaignTo': json['campaignTo'] == null ? undefined : (new Date(json['campaignTo'])),
        'campaignFrom': json['campaignFrom'] == null ? undefined : (new Date(json['campaignFrom'])),
        'shortDescription': json['shortDescription'] == null ? undefined : json['shortDescription'],
        'longDescription': json['longDescription'] == null ? undefined : json['longDescription'],
        'relatedProductIds': json['relatedProductIds'] == null ? undefined : json['relatedProductIds'],
        'price': json['price'] == null ? undefined : PriceFromJSON(json['price']),
        'primaryTag': json['primaryTag'] == null ? undefined : json['primaryTag'],
        'productType': json['productType'] == null ? undefined : json['productType'],
        'seoTitle': json['seoTitle'] == null ? undefined : json['seoTitle'],
        'estimatedShippingPrice': json['estimatedShippingPrice'] == null ? undefined : PriceFromJSON(json['estimatedShippingPrice']),
        'seoDescription': json['seoDescription'] == null ? undefined : json['seoDescription'],
        'id': json['id'] == null ? undefined : json['id'],
        'name': json['name'] == null ? undefined : json['name'],
        'url': json['url'] == null ? undefined : json['url'],
        'addons': json['addons'] == null ? undefined : ((json['addons'] as Array<any>).map(AddonModelFromJSON)),
        'splash': json['splash'] == null ? undefined : ProductSplashDiscountModelFromJSON(json['splash']),
        'designer': json['designer'] == null ? undefined : json['designer'],
        'googleProductCategory': json['googleProductCategory'] == null ? undefined : json['googleProductCategory'],
        'variantGroups': json['variantGroups'] == null ? undefined : (mapValues(json['variantGroups'], VariantGroupFromJSON)),
        'variantTypes': json['variantTypes'] == null ? undefined : ((json['variantTypes'] as Array<any>).map(VariantTypeFromJSON)),
        'variantPrices': json['variantPrices'] == null ? undefined : json['variantPrices'],
        'options': json['options'] == null ? undefined : (mapValues(json['options'], VariantOptionFromJSON)),
        'specifications': json['specifications'] == null ? undefined : ((json['specifications'] as Array<any>).map(SpecificationFromJSON)),
        'brand': json['brand'] == null ? undefined : json['brand'],
        'images': json['images'] == null ? undefined : json['images'],
        'priceDictionary': json['priceDictionary'] == null ? undefined : (mapValues(json['priceDictionary'], PriceFromJSON)),
        'categoryGroupCustomizerSelectionTitle': json['categoryGroupCustomizerSelectionTitle'] == null ? undefined : json['categoryGroupCustomizerSelectionTitle'],
    };
}

export function ProductModelToJSON(value?: ProductModel | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'campaignTo': value['campaignTo'] == null ? undefined : ((value['campaignTo'] as any).toISOString()),
        'campaignFrom': value['campaignFrom'] == null ? undefined : ((value['campaignFrom'] as any).toISOString()),
        'shortDescription': value['shortDescription'],
        'longDescription': value['longDescription'],
        'relatedProductIds': value['relatedProductIds'],
        'price': PriceToJSON(value['price']),
        'primaryTag': value['primaryTag'],
        'productType': value['productType'],
        'seoTitle': value['seoTitle'],
        'estimatedShippingPrice': PriceToJSON(value['estimatedShippingPrice']),
        'seoDescription': value['seoDescription'],
        'id': value['id'],
        'name': value['name'],
        'url': value['url'],
        'addons': value['addons'] == null ? undefined : ((value['addons'] as Array<any>).map(AddonModelToJSON)),
        'splash': ProductSplashDiscountModelToJSON(value['splash']),
        'designer': value['designer'],
        'googleProductCategory': value['googleProductCategory'],
        'variantGroups': value['variantGroups'] == null ? undefined : (mapValues(value['variantGroups'], VariantGroupToJSON)),
        'variantTypes': value['variantTypes'] == null ? undefined : ((value['variantTypes'] as Array<any>).map(VariantTypeToJSON)),
        'variantPrices': value['variantPrices'],
        'options': value['options'] == null ? undefined : (mapValues(value['options'], VariantOptionToJSON)),
        'specifications': value['specifications'] == null ? undefined : ((value['specifications'] as Array<any>).map(SpecificationToJSON)),
        'brand': value['brand'],
        'images': value['images'],
        'priceDictionary': value['priceDictionary'] == null ? undefined : (mapValues(value['priceDictionary'], PriceToJSON)),
        'categoryGroupCustomizerSelectionTitle': value['categoryGroupCustomizerSelectionTitle'],
    };
}

